export default "__VITE_ASSET__cd7108d2__"